import { ActiveFilters, SEARCH_DEFAULT_SORT_BY } from 'store/search/types';

function getFilters(filters: ActiveFilters) {
  try {
    if (!Object.values(filters).length) {
      return '';
    }
    return encodeURIComponent(JSON.stringify(filters));
  } catch (e) {
    console.error('Error preparing filters string', e);
  }
  return '';
}

export default function composeSearchPageQuery(query: string, pageNr: number, sortBy: string, filters: ActiveFilters) {
  const params: string[] = [];

  params.push(`query=${query}`);
  if (pageNr !== 1) {
    params.push(`pageNr=${pageNr}`);
  }
  if (sortBy !== SEARCH_DEFAULT_SORT_BY) {
    params.push(`sortBy=${sortBy}`);
  }
  const filtersString = getFilters(filters);
  if (filtersString) {
    params.push(`filters=${filtersString}`);
  }
  return `?${params.join('&')}`;
}
